"use client";

import { useEffect, useState } from "react";
import { getCoupon, subscribeToCouponStore } from "./coupon";

/**
 * Returns `true` when a recognized coupon trigger is active for this visitor.
 *
 * The pre-hydration inline script in `app/layout.tsx` sets `html.has-coupon`
 * synchronously on first paint. This hook re-syncs the class whenever the
 * coupon store mutates after hydration — PricingContent's mount-effect
 * (`captureCouponFromUrl`) is the canonical late writer.
 */
export function useHasActiveCoupon(): boolean {
  // Match the server-rendered snapshot for the first hydrated render. Reading
  // localStorage here makes Navbar compute a different Login href on the
  // client than the server rendered, which React reports as a hydration
  // mismatch. The effect below syncs the real coupon state after mount.
  const [hasCoupon, setHasCoupon] = useState(false);

  useEffect(() => {
    const sync = () => {
      const has = getCoupon() !== null;
      const root = document.documentElement;
      if (has) {
        root.classList.add("has-coupon");
      } else {
        root.classList.remove("has-coupon");
      }
      setHasCoupon(has);
    };
    sync();
    return subscribeToCouponStore(sync);
  }, []);

  return hasCoupon;
}
